import { useRef } from 'react';

import { ConsignmentEditForm, type ConsignmentEditFormRef } from '@/widgets/consignment-edit-form';

import { useConsignmentNavigation, useConsignmentEdit } from '../lib';
import { PageHeader, NavigationControls, SaveButton, ShowDispositionButton, EmptyState } from './index';

export function ConsignmentEditPage() {
  const formRef = useRef<ConsignmentEditFormRef>(null);

  const {
    currentConsignmentId,
    isMultipleConsignments,
    currentIndex,
    totalConsignments,
    canGoPrevious,
    canGoNext,
    handlePrevious,
    handleNext,
    handleBack
  } = useConsignmentNavigation();

  const { handleSave, isLoading, consignmentData, isReadOnly } = useConsignmentEdit(currentConsignmentId);

  const handleFormSubmit = () => {
    formRef.current?.submit();
  };

  if (!currentConsignmentId) {
    return <EmptyState />;
  }

  return (
    <div className="pb-32 sm:pb-6 space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:sticky sm:-top-4 md:-top-6 sm:-mt-4 md:-mt-6 sm:z-20 sm:-mx-4 sm:px-4 md:-mx-6 md:px-6 sm:py-3 sm:border-b sm:bg-background">
        <PageHeader onBack={handleBack} />

        {isMultipleConsignments && (
          <NavigationControls
            currentIndex={currentIndex}
            totalConsignments={totalConsignments}
            canGoPrevious={canGoPrevious}
            canGoNext={canGoNext}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        )}

        <div className="flex flex-wrap gap-2 sm:flex-nowrap sm:items-center fixed inset-x-0 bottom-0 z-20 border-t bg-background p-4 sm:static sm:z-auto sm:ml-auto sm:border-0 sm:bg-transparent sm:p-0">
          <ShowDispositionButton consignmentId={currentConsignmentId} />
          <SaveButton onClick={handleFormSubmit} isLoading={isLoading} isReadOnly={isReadOnly} />
        </div>
      </div>

      <ConsignmentEditForm
        ref={formRef}
        consignmentId={currentConsignmentId}
        consignmentData={consignmentData}
        isReadOnly={isReadOnly}
        isLoading={isLoading}
        onSave={handleSave}
      />
    </div>
  );
}
